// src/pages/Teams.js
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Card, Alert, Spinner } from 'react-bootstrap';
import useTeamStore from '../store/teamStore';
import TeamCard from '../components/Teams/TeamCard';
import TeamForm from '../components/Teams/TeamForm';
import { Modal, ConfirmModal } from '../components/UI/Modal';

const Teams = () => {
    const { teams, fetchTeams, createTeam, updateTeam, deleteTeam, loading, error } = useTeamStore();
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [currentTeam, setCurrentTeam] = useState(null);

    useEffect(() => {
        fetchTeams();
    }, [fetchTeams]);

    const handleCreateTeam = async (teamData) => {
        try {
            await createTeam(teamData);
            setShowCreateModal(false);
        } catch (err) {
            // Chyba je zachycena v store a zobrazena přes Toast
        }
    };

    const handleEditTeam = (teamId) => {
        const team = teams.find(t => t.id === teamId);
        if (team) {
            setCurrentTeam(team);
            setShowEditModal(true);
        }
    };

    const handleUpdateTeam = async (teamData) => {
        try {
            await updateTeam(currentTeam.id, teamData);
            setShowEditModal(false);
            setCurrentTeam(null);
        } catch (err) {
            // Chyba je zachycena v store a zobrazena přes Toast
        }
    };

    const handleDeleteClick = (teamId) => {
        const team = teams.find(t => t.id === teamId);
        if (team) {
            setCurrentTeam(team);
            setShowDeleteModal(true);
        }
    };

    const handleDeleteConfirm = async () => {
        if (currentTeam) {
            try {
                await deleteTeam(currentTeam.id);
                setShowDeleteModal(false);
                setCurrentTeam(null);
            } catch (err) {
                // Chyba je zachycena v store a zobrazena přes Toast
            }
        }
    };

    return (
        <Container fluid>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1>Moje týmy</h1>
                <Button
                    variant="primary"
                    onClick={() => setShowCreateModal(true)}
                >
                    <i className="fas fa-plus me-2"></i> Vytvořit nový tým
                </Button>
            </div>

            {error && <Alert variant="danger">{error}</Alert>}

            {loading && teams.length === 0 ? (
                <div className="text-center py-5">
                    <Spinner animation="border" role="status" variant="primary">
                        <span className="visually-hidden">Načítání týmů...</span>
                    </Spinner>
                </div>
            ) : teams.length === 0 ? (
                <Card className="text-center p-5">
                    <Card.Body>
                        <i className="fas fa-users fa-4x text-muted mb-3"></i>
                        <h3>Žádné týmy</h3>
                        <p className="text-muted mb-4">Zatím jste nevytvořili žádné týmy. Začněte vytvořením prvního týmu.</p>
                        <Button
                            variant="primary"
                            onClick={() => setShowCreateModal(true)}
                        >
                            <i className="fas fa-plus me-2"></i> Vytvořit tým
                        </Button>
                    </Card.Body>
                </Card>
            ) : (
                <Row xs={1} sm={2} lg={3} xl={4} className="g-4">
                    {teams.map(team => (
                        <Col key={team.id}>
                            <TeamCard
                                team={team}
                                onEdit={handleEditTeam}
                                onDelete={handleDeleteClick}
                            />
                        </Col>
                    ))}
                </Row>
            )}

            {/* Modální okna */}
            <Modal
                isOpen={showCreateModal}
                onClose={() => setShowCreateModal(false)}
                title="Vytvořit nový tým"
            >
                <TeamForm
                    onSubmit={handleCreateTeam}
                    loading={loading}
                />
            </Modal>

            <Modal
                isOpen={showEditModal}
                onClose={() => {
                    setShowEditModal(false);
                    setCurrentTeam(null);
                }}
                title="Upravit tým"
            >
                <TeamForm
                    team={currentTeam}
                    onSubmit={handleUpdateTeam}
                    loading={loading}
                />
            </Modal>

            <ConfirmModal
                isOpen={showDeleteModal}
                onClose={() => {
                    setShowDeleteModal(false);
                    setCurrentTeam(null);
                }}
                onConfirm={handleDeleteConfirm}
                title="Potvrzení smazání týmu"
                message={`Opravdu chcete smazat tým "${currentTeam?.name}"? Tato akce odstraní tým a odebere všechna přiřazení webů a uživatelů. Samotné weby nebudou odstraněny.`}
                confirmText="Ano, smazat tým"
                cancelText="Zrušit"
                variant="danger"
            />
        </Container>
    );
};

export default Teams;